import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

interface ConfirmRegenerateDocumentDialogProps {
  confirmRegenOpen: boolean;
  setConfirmRegenOpen: (value: boolean) => void;
  handleConfirmRegen: () => void;
  isGeneratingDocument?: boolean;
}
export const ConfirmRegenerateDocumentDialog = ({
  confirmRegenOpen,
  setConfirmRegenOpen,
  handleConfirmRegen,
  isGeneratingDocument
}: ConfirmRegenerateDocumentDialogProps) => (
  <Dialog open={confirmRegenOpen} onClose={() => setConfirmRegenOpen(false)} maxWidth="xs" fullWidth>
    <DialogTitle>Přegenerovat podepsaný dokument?</DialogTitle>
    <DialogContent>
      <Typography variant="body2">
        Dokument je již podepsaný. Pokud ho přegenerujete, bude nutné ho znovu podepsat.
      </Typography>
    </DialogContent>
    <DialogActions
      sx={{
        py: 4,
        justifyContent: 'center',
        flexDirection: { xs: 'column-reverse', md: 'row' },
        gap: 2
      }}
    >
      <Button onClick={() => setConfirmRegenOpen(false)}>Zrušit</Button>
      <Button onClick={handleConfirmRegen} variant="contained" disabled={isGeneratingDocument}>
        Přegenerovat
      </Button>
    </DialogActions>
  </Dialog>
);
